module.exports = __webpack_public_path__ + "media/images/recruitment/landing/icon_complete_left-df91c400cea198b1b93ef60406db232d.svg";